export default __webpack_public_path__ + "static/media/drone_light.49b3089c.png";